<template>
  <label :class="{'required': field.required}" :for="`select-dataset-input-${parent}-${field.name}`">
    {{ field.label ? field.label : field.Label ? field.Label : field.name }}
    <SVGIcon
      v-if="field.description"
      v-tooltip="field.description"
      :width="'20px'"
      :height="'20px'"
      :iconName="'info'"
      class="help-logo"
    />
  </label>
  <select
    :id="`select-dataset-input-${parent}-${field.name}`"
    :value="modelValue"
    class="select"
    @input="$emit('update:modelValue', $event.target.value)"
  >
    <option
      v-for="(dataset, i) in datasets"
      :key="`dropdown-${parent}-${field.name}-${i}-${dataset.name}`"
      :value="dataset.id"
    >
      {{ dataset.name }}
    </option>
  </select>

  <!-- <template v-if="getSelectChildren(field)">
          <ConfigureFieldsGroup
            v-for="childKey in Object.keys(parameters[field.name])"
            :id="`parent-${field.name}`"
            :key="childKey"
            v-model:params="parameters[field.name][childKey]"
            :fields="getSelectChildren(field)"
            :parent="field.name"
          />
        </template> -->
</template>

<script setup>
import {
  ref, computed, toRefs, onMounted,
} from 'vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useStore } from 'vuex';

const props = defineProps({
  parent: {
    type: String,
    default: "",
  },
  field: {
    type: Object,
    default: () => {},
  },
  modelValue: {
    type: Object,
    default: null,
  },
});

const {
  parent,
  field,
} = toRefs(props);

const emit = defineEmits(['update:modelValue']);

async function getDatasets() {
  if (currentProject.value) {
    const dataConnect = new DatastoreConnect();
    const datasets = await dataConnect.getDatasetList({
      project_id: currentProject.value.id,
      get_annotation_sets: true,
      get_groups: true,
    })
      .then((resp) => {
        if (resp.error) {
          throw resp.error;
        }
        return resp.result;
      })
      .catch((error) => {
        console.error(error);
      });

    console.log(datasets);
    return datasets;
  }
  return [];
}

const store = useStore();
const currentProject = computed(() => store.state.projects.currentProject);
const datasets = ref(null);

onMounted(async () => {
  datasets.value = await getDatasets();
  if (datasets.value.length > 0) {
    emit('update:modelValue', datasets.value[0].id);
  }
});
</script>
